<template>
  <a-modal
    wrapClassName="create-user-modal"
    :visible="visible"
    :width="600"
    centered
    :mask-closable="false"
    :closable="false"
  >
    <template #title>
      <header>
        <div>
          Crear nuevos usuarios
          <!-- <a-tag> Usuarios 0 </a-tag> -->
        </div>

        <a-button type="text" aria-label="Close" @click="handleCloseModal">
          <CloseOutlined />
        </a-button>
      </header>
    </template>

    <h4>Crea nuevos usuarios con correos electrónicos aleatorios</h4>

    <p>
      Selecciona un perfil y agrega la cantidad de usuarios que necesitas, estos usuarios serán
      creados con correos y contraseñas aleatorios. Descarga y/o copia las credenciales al final.
    </p>

    <CustomScrollbar height="340px">
      <a-form class="form" layout="vertical">
        <template v-for="(profile, index) in profilesCount" :key="index">
          <div class="selector">
            <a-form-item label="Perfil asignado" required>
              <ProfilePickerVue v-model:value="profile.profile" />
            </a-form-item>

            <a-form-item label="Número de usuarios " required>
              <a-input-number
                v-model:value="profile.quantity"
                placeholder="Escribir aquí"
                :precision="0"
                :min="1"
              />
            </a-form-item>
          </div>

          <div class="button__wrapper button__wrapper-right" v-if="profilesCount.length > 1">
            <a-button class="button-delete" type="link" danger @click="handleDelete(index)">
              Eliminar sección
            </a-button>
          </div>

          <a-divider type="horizontal" class="divider" />
        </template>
      </a-form>
    </CustomScrollbar>
    <div class="button__wrapper button__wrapper-center">
      <a-button type="link" @click="handleAdd">
        <PlusOutlined />
        Agregar invitación para otro perfil
      </a-button>
    </div>

    <template #footer>
      <a-button key="back" @click="handleBack">Volver</a-button>
      <a-button
        id="create-credentials"
        key="submit"
        type="primary"
        :loading="loading"
        @click="handleCreate"
        :disabled="profilesCount.some((profile) => !(profile.quantity && profile.profile))"
      >
        Crear y descargar credenciales
      </a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { h, ref, computed } from "vue";
import { PlusOutlined, CloseOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { Modal, message } from "ant-design-vue";
import { useStore } from "vuex";

import { UserCreationType } from "../../utils/constants";
import { downloadFile } from "@/app/shared/utils/file";
import { ResponseError } from "@/app/shared/utils/httpManager";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import ProfilePickerVue from "@/app/shared/components/pickers/ProfilePicker.vue";

const props = defineProps<{ visible: boolean, slotsInfo: any, isClientBeexcc: boolean }>();

const emit = defineEmits<{
  (event: "update:visible", visible: boolean): void;
  (event: "back"): void;
  (event: "update"): void;
  (event: "openBuyModal", slots: number): void;
}>();

const store = useStore();

interface Invitation {
  profile?: number;
  quantity?: number;
}

// const profilesCount = ref(1);
// const formState = reactive<Record<number, Invitation>>({
//   1: { count: undefined, profile: undefined },
// });
const profilesCount = ref<Invitation[]>([{ quantity: undefined, profile: undefined }]);

const handleAdd = () => {
  profilesCount.value.push({ quantity: undefined, profile: undefined });
};

const handleDelete = (index: number) => {
  profilesCount.value.splice(index, 1);
};

const handleCloseModal = () => emit("update:visible", false);

const handleBack = (e: unknown) => {
  console.log(e);
  emit("back");
  handleCloseModal();
};

const loading = ref(false);

const remainingSlots = computed(
  // () => (props.slotsInfo?.slots_invoice ?? 0) - (props.slotsInfo?.slot_assigned ?? 0)
  () => remainingPrepaidSlots.value
);

const remainingPrepaidSlots = computed(
  () =>
    (props.slotsInfo?.slots_invoice ?? 0) -
    (props.slotsInfo?.slot_assigned ?? 0) -
    (props.slotsInfo?.slot_deleted ?? 0)
);

const handleCreate = async () => {
  loading.value = true;

  try {
    const body = {
      type: UserCreationType.Generated,
      users: profilesCount.value,
    };

    const response = await store.dispatch("createNewUser", body);

    downloadFile(response, "users.txt", { useResponseFileName: true });

    emit("update");
    handleCloseModal();
  } catch (error) {
    let errorMessage = "Ha ocurrido un error";

    if (error instanceof ResponseError) {
      if (error.status === 400) {
        const slotsCreated = profilesCount.value.reduce((sum, item) => sum + (item?.quantity ?? 0), 0);
        const slotsAvailible = props.slotsInfo?.slot_type_billing === 'Postpago' ? remainingSlots.value : remainingPrepaidSlots.value;
        const neededSlots = slotsCreated - slotsAvailible;
        const totalSlots = (props.slotsInfo?.slots_invoice ?? 0) - (props.slotsInfo?.slot_deleted ?? 0);
        // const neededSlots = error.data.slots_used;
        
        const modalType = props.isClientBeexcc ? Modal.warning : Modal.confirm;

        modalType({
          centered: true,
          icon: h(ExclamationCircleOutlined),
          title: props.isClientBeexcc
            ? "No cuentas con slots suficientes para crear nuevos usuarios"
            : `Necesitas "${neededSlots}" slots para crear nuevos usuarios en la plataforma`,
          content: props.isClientBeexcc
            ? `Actualmente, no puedes crear más de ${totalSlots} usuarios en la plataforma. Para agregar más slots, contáctate con tu Partner.`
            : `Actualmente, no cuentas con slots disponibles para crear "${slotsCreated}" usuarios nuevos en la plataforma.`,
          okText: props.isClientBeexcc ? "Entendido" : "Comprar slots",
          okType: props.isClientBeexcc ? "default" : "primary",
          onOk: props.isClientBeexcc ? undefined : () => emit("openBuyModal", neededSlots),
        });
      } else {
        errorMessage = error.getErrorMessage();
        message.error(errorMessage);
        console.log(error);
      }
    }
  }

  loading.value = false;
  // emit("click:invite");
};
</script>

<style scoped lang="sass">
header
  display: flex
  align-items: center
  justify-content: space-between

h4
  font-weight: 600
  font-size: 16px

p
  color: $gray-9

.form
  max-width: 80%
  margin: 0 auto

.selector
  display: grid
  grid-template-columns: 1.2fr 0.8fr
  gap: 0 16px

.button
  &__wrapper
    width: 100%

    &-right
      text-align: right

    &-center
      text-align: center

  &-delete
    padding: 0

.divider
  margin: 16px 0
  background-color: $gray-4

.ant-input-number
  width: 100%

.ant-form-item
  margin: 0
</style>
